// React
import React from "react";
import ReactDOM from "react-dom";

// React Router
import { HashRouter, Route } from "react-router-dom";

// Material-UI
import { MuiThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";

// PWA
import * as serviceWorker from "./serviceWorker";

// App-specific
import App from "./App";
import UserContextProvider from "contexts/UserContext";
import SearchContextProvider from "contexts/SearchContext";
import "./index.css";
import { Theme } from "./theme";

// esri-loader
import { setDefaultOptions } from "esri-loader";
setDefaultOptions({ version: "next", css: true });

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <MuiThemeProvider theme={Theme}>
        <HashRouter>
          <UserContextProvider>
            <SearchContextProvider>
              <Route path="/" component={App} />
            </SearchContextProvider>
          </UserContextProvider>
        </HashRouter>
      </MuiThemeProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
